import { Injectable } from "@angular/core";
import { DPO_CONSTANT } from './../utils/constant';
import { HttpService } from './http.service';
import { AppConfig } from '../modules/app.config';   //CAP-20753: Imported AppConfig file for Client related Changes
import { CacheService } from './cache.service';
// Common Service to handle the common API calls
@Injectable()
export class CommonService {

    
    constructor(private httpService: HttpService, private apiconfig :AppConfig, private cacheService: CacheService,) {    //CAP-20753: Added AppConfig in Constructor for Client related Changes
    }

    // Method to call a API for login authentication.
    public authenticateLogin(params: any) {
        const queryParams = this.httpService.prepareQueryParams(params);
        const finalUrl = DPO_CONSTANT.AUTHENTICATE_LOGIN + queryParams;
        return this.httpService.get(finalUrl);
    }

    // Method to call a API for token authentication
    /* Cap-20753 : Start: Added params in the function */
    public authenticateToken( params: any, token :any, headerParams:any) {
        console.log("The common ervice header value 1 is :" + headerParams);
        const queryParams = this.httpService.prepareQueryParams(params);
        const finalUrl = DPO_CONSTANT.AUTHENTICATE_TOKEN + queryParams;
        console.log("final url in common" + finalUrl);
        if(token === undefined){
            return this.httpService.get(finalUrl);
        }
        //START - CAP_20753:PART-2: POI BASEAUTH - HEADER EXTRACTION
        else if(this.cacheService.getItem(DPO_CONSTANT.CACHE_APPLICATION_NAME) === DPO_CONSTANT.POI) {
            return this.httpService.getBaseAuth(finalUrl, headerParams);
        } 
        //STOP - CAP_20753:PART-2: POI BASEAUTH - HEADER EXTRACTION
        else {
            return this.httpService.getCallForToken(finalUrl, token);
        }
    }
    /* Cap-20753: End */

    // Method to call a API for validating a token
    public validateToken(token: string) {
        const finalUrl = DPO_CONSTANT.VALIDATE_TOKEN;
        return this.httpService.getCallForToken(finalUrl, token);
    }

    // Method to call a API for authenticate delegation
    public authenticateDelegation(params: any) {
        const queryParams = this.httpService.prepareQueryParams(params);
        const finalUrl = DPO_CONSTANT.SUBSCRIPTION_DELEGATION + queryParams;
        return this.httpService.get(finalUrl);
    }

    // Method to call a API for loading all the languages
   //CAP-20457: LOT1.1: START - LOAD LANGUAGES FOR PANEL + Translation Service changed to translate for JSON
    public loadLanguages() {
        const finalUrl = DPO_CONSTANT.LANGUAGES;
        return this.httpService.get(finalUrl);
    }
    //CAP-20457: LOT1.1: STOP - LOAD LANGUAGES FOR PANEL + Translation Service changed to translate for JSON

    //CAP-20753: LOT1.1: START - isAlive Method created to fetch the API response
    public isAlive() {
        const finalUrl = DPO_CONSTANT.ISALIVE;
        return this.httpService.get(finalUrl);
    }
    //CAP-20753: LOT1.1: STOP - isAlive Method created to fetch the API response
}
